import React, { useState } from 'react'
import { useStyles } from './FlyoutLandingPageSection.styles'
import { FormLockedType } from '../../../../types/FormLockedType'
import { landingPageImages } from '../../../../common/utils/productCreationUtil'
import EmptyProductListing from '../../../../common/images/EmptyProductListing.png'
import { FormikProps, useFormikContext } from 'formik'
import {
  Carousel,
  LabraToolTipV2,
  ModalConfirmV2,
  ModalSizeVariants,
  PlanType,
  SwitchV2,
  SwitchVarient,
} from '@labrav/react-components'

import { awsRequirementsLink } from '../../../../common/utils/constants'
import {
  FlyoutProductSections,
  FlyoutProductAddEditSectionName,
} from '../../../../types/addEditProduct'
import { FlyOutProductAdhere } from '../../../AddEditProductFormComponents/FlyOutProductAdhere/FlyOutProductAdhere'
import { FlyOutProductLandingPageConfiguration } from '../../../AddEditProductFormComponents/FlyOutProductLandingPageConfiguration/FlyOutProductLandingPageConfiguration'
import { FlyOutProductBranding } from '../../../AddEditProductFormComponents/FlyOutProductBranding/FlyOutProductBranding'
import { defaultNow } from '../../../../common/utils/dateTimeNow'
import { FlyOutProductFormFields } from '../../../AddEditProductFormComponents/FlyOutProductFormFields/FlyOutProductFormFields'
import { FlyOutProductRedirectionSettings } from '../../../AddEditProductFormComponents/FlyOutProductRedirectionSettings/FlyOutProductRedirectionSettings'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAws } from '@fortawesome/free-brands-svg-icons'
import { Typography } from '@mui/material'
import {
  EmptyState,
  SupportTicketButton,
} from '../../../../common/components/EmptyState/EmptyState'
import { isBoolean } from 'lodash'
export interface FlyoutLandingPageSectionProps {
  detailView?: boolean
  detailViewTooltip?: string
  productView?: boolean
}

export const FlyoutLandingPageSection = ({
  isFormLocked,
  detailView,
  detailViewTooltip,
  productView,
}: FlyoutLandingPageSectionProps & FormLockedType) => {
  const { classes } = useStyles()
  const [indexModal, setIndexModal] = useState(0)
  const [open, setOpen] = useState(false)

  const handleRefLinkClick = (index: number) => {
    setIndexModal(index)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }
  const noOps = () => void 0
  const { values, setFieldValue } =
    useFormikContext() as FormikProps<FlyoutProductSections>
  const productType = values.productDetails.productType
  const isProfessionalService = productType === PlanType.PROFESSIONAL_SERVICES
  const requirementsLink = isProfessionalService ? '' : awsRequirementsLink

  const isHostWithLabra = isBoolean(
    values?.[FlyoutProductAddEditSectionName.GENERAL_INFORMATION].hostWithLabra
  )
    ? values?.[FlyoutProductAddEditSectionName.GENERAL_INFORMATION]
        .hostWithLabra
    : true

  const contentEmptyState = (
    <div className={classes.subHeadingContainer}>
      <Typography className={classes.subHeading}>
        This is a Labra Enterprise plan feature which allows your buyers after
        purchasing your product on AWS marketplace to be redirected to a
        registration page hosted elsewhere.
        <Typography className={classes.subHeading}>
          To enable this feature, please reach out to our customer support team!
        </Typography>
      </Typography>
      <Typography className={classes.subHeading}>
        <span className={classes.note}>Note:</span> Till the request is not made
        manually, your listing will be created with a buyer registration page
        hosted by Labra.
      </Typography>
    </div>
  )
  const handleChangeHostWithLabra = (e: {
    target: {
      checked: boolean
    }
  }) => {
    setFieldValue('generalInformation.hostWithLabra', e?.target?.checked)
  }

  return (
    <div className={classes.container} data-testid={'landing-page'}>
      <div className={classes.switchBanner}>
        <div className={classes.hostWithLabra}>
          <Typography className={classes.bannerDescription}>
            Host your buyer registration page elsewhere by using this option.
          </Typography>
        </div>
        <LabraToolTipV2
          followCursor={detailView}
          tooltipPlacement="bottom-start"
          description={detailViewTooltip}
        >
          <div className={classes.hostWithLabra}>
            <Typography className={classes.bannerDescription}>
              Host with Labra
            </Typography>
            <SwitchV2
              checked={isHostWithLabra}
              onChange={handleChangeHostWithLabra}
              switchVarient={SwitchVarient.DARK}
              disabled={isFormLocked || detailView}
            />
          </div>
        </LabraToolTipV2>
      </div>
      {!isHostWithLabra ? (
        <EmptyState
          imgSrc={EmptyProductListing}
          header="Host your own buyer registration page."
          content={contentEmptyState}
          action={<SupportTicketButton />}
        />
      ) : (
        <>
          <FlyOutProductBranding
            isFormLocked={isFormLocked}
            defaultNow={defaultNow}
            detailView={detailView}
            detailViewTooltip={detailViewTooltip}
            handleRefLinkClick={handleRefLinkClick}
            productView={productView}
          />
          <FlyOutProductLandingPageConfiguration
            isFormLocked={isFormLocked}
            detailView={detailView}
            detailViewTooltip={detailViewTooltip}
            handleRefLinkClick={handleRefLinkClick}
          />
          <FlyOutProductFormFields
            isFormLocked={isFormLocked}
            detailView={detailView}
            detailViewTooltip={detailViewTooltip}
            handleRefLinkClick={handleRefLinkClick}
          />
          <FlyOutProductRedirectionSettings
            isFormLocked={isFormLocked}
            detailView={detailView}
            detailViewTooltip={detailViewTooltip}
            handleRefLinkClick={handleRefLinkClick}
          />
          {!productView && (
            <FlyOutProductAdhere
              requirementsLink={requirementsLink}
              sectionName={FlyoutProductAddEditSectionName.LANDING_PAGE_DETAILS}
              isFormLocked={isFormLocked}
            />
          )}
        </>
      )}

      <ModalConfirmV2
        title={`${landingPageImages[indexModal].heading}`}
        description={''}
        icon={
          <FontAwesomeIcon
            icon={faAws}
            style={{ height: '16px', width: '16px' }}
          />
        }
        content={
          <Carousel
            showHeading={false}
            carouselData={landingPageImages}
            handleImageClick={noOps}
            setCurrentIndex={setIndexModal}
            currentIndex={indexModal}
          />
        }
        open={open}
        titleAcceptButton={''}
        titleCancelButton={''}
        onDecline={handleClose}
        variant={ModalSizeVariants.large}
        hideAcceptButton={true}
        hideCancelButton={true}
        onAccept={noOps}
      />
    </div>
  )
}
